import type {SVGProps} from 'react'
import {useId} from 'react'
const GradientCheckmarkIcon = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      width="1em"
      height="1em"
      overflow="visible"
      style={{
        display: 'block',
      }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Outline">
        <g id="Intersect">
          <path
            d="M7 1.2V0C3.13401 0 0 3.13401 0 7H1.2C1.2 3.79675 3.79675 1.2 7 1.2Z"
            fill={`url(#${uid}paint0_linear_13120_20357)`}
          />
          <path
            d="M7 1.2V0C3.13401 0 0 3.13401 0 7H1.2C1.2 3.79675 3.79675 1.2 7 1.2Z"
            fill={`url(#${uid}paint1_linear_13120_20357)`}
          />
        </g>
        <g id="Intersect_2">
          <path
            d="M12.8 7H14C14 3.13401 10.866 0 7 0V1.2C10.2033 1.2 12.8 3.79675 12.8 7Z"
            fill={`url(#${uid}paint2_linear_13120_20357)`}
          />
          <path
            d="M12.8 7H14C14 3.13401 10.866 0 7 0V1.2C10.2033 1.2 12.8 3.79675 12.8 7Z"
            fill={`url(#${uid}paint3_linear_13120_20357)`}
          />
        </g>
        <g id="Intersect_3">
          <path
            d="M12.8 7C12.8 10.2033 10.2033 12.8 7 12.8V14C10.866 14 14 10.866 14 7H12.8Z"
            fill={`url(#${uid}paint4_linear_13120_20357)`}
          />
          <path
            d="M12.8 7C12.8 10.2033 10.2033 12.8 7 12.8V14C10.866 14 14 10.866 14 7H12.8Z"
            fill={`url(#${uid}paint5_linear_13120_20357)`}
          />
        </g>
        <g id="Intersect_4">
          <path
            d="M1.2 7H0C0 10.866 3.13401 14 7 14V12.8C3.79675 12.8 1.2 10.2033 1.2 7Z"
            fill={`url(#${uid}paint6_linear_13120_20357)`}
          />
          <path
            d="M1.2 7H0C0 10.866 3.13401 14 7 14V12.8C3.79675 12.8 1.2 10.2033 1.2 7Z"
            fill={`url(#${uid}paint7_linear_13120_20357)`}
          />
        </g>
        <path
          id="Stroke"
          d="M4.5 6.90039L6.47581 8.90039L9.9002 4.90039"
          stroke="var(--stroke-0, #2D2E2C)"
          strokeWidth={0.9}
        />
      </g>
      <defs>
        <linearGradient
          id={`${uid}paint0_linear_13120_20357`}
          x1={1}
          y1={7}
          x2={7}
          y2={1}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E42922" />
          <stop offset={1} stopColor="#2085CE" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint1_linear_13120_20357`}
          x1={0.875}
          y1={7}
          x2={7}
          y2={0.875}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2085CE" />
          <stop offset={1} stopColor="#58B64A" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint2_linear_13120_20357`}
          x1={7}
          y1={1}
          x2={13}
          y2={7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2085CE" />
          <stop offset={0.0498047} stopColor="#2387C7" />
          <stop offset={1} stopColor="#58B64A" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint3_linear_13120_20357`}
          x1={7}
          y1={0.875}
          x2={13.125}
          y2={7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B64A" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint4_linear_13120_20357`}
          x1={13}
          y1={7}
          x2={7}
          y2={13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B64A" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint5_linear_13120_20357`}
          x1={13.125}
          y1={7}
          x2={7}
          y2={13.125}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DC9F1C" />
          <stop offset={1} stopColor="#E42922" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint6_linear_13120_20357`}
          x1={7}
          y1={13}
          x2={1}
          y2={7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DC9F1C" />
          <stop offset={1} stopColor="#E42922" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint7_linear_13120_20357`}
          x1={7}
          y1={13.125}
          x2={0.875}
          y2={7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E42922" />
          <stop offset={1} stopColor="#2085CE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export {GradientCheckmarkIcon}
